import {
  ChecklistIcon,
  DamageDentIcon,
  DamageMissingTrimIcon,
  MOT,
  PetrolIcon,
  SpannerIcon,
  VehiclePassengerSideIcon,
} from '@motorway/mw-highway-code';

export const motContentBody = (wpData: { [key: string]: string }) => [
  {
    contentBodyArea: wpData?.ulez_content_one_body,
    id: 1,
    imgSrc: <DamageMissingTrimIcon />,
    title: wpData?.ulez_content_one_title,
  },
  {
    contentBodyArea: wpData?.ulez_content_two_body,
    id: 2,
    imgSrc: <SpannerIcon />,
    title: wpData?.ulez_content_two_title,
  },
  {
    contentBodyArea: wpData?.ulez_content_three_body,
    id: 3,
    imgSrc: <PetrolIcon />,
    title: wpData?.ulez_content_three_title,
  },
  {
    contentBodyArea: wpData?.ulez_content_four_body,
    id: 4,
    imgSrc: <ChecklistIcon />,
    title: wpData?.ulez_content_four_title,
  },
];

export const taxContentBody = (wpData: { [key: string]: string }) => [
  {
    contentBodyArea: wpData?.ulez_content_one_body,
    id: 1,
    imgSrc: <VehiclePassengerSideIcon />,
    title: wpData?.ulez_content_one_title,
  },
  {
    contentBodyArea: wpData?.ulez_content_two_body,
    id: 2,
    imgSrc: <MOT />,
    title: wpData?.ulez_content_two_title,
  },
  {
    contentBodyArea: wpData?.ulez_content_three_body,
    id: 3,
    imgSrc: <PetrolIcon />,
    title: wpData?.ulez_content_three_title,
  },
  {
    contentBodyArea: wpData?.ulez_content_four_body,
    id: 4,
    imgSrc: <DamageDentIcon />,
    title: wpData?.ulez_content_four_title,
  },
];
